module.exports = __webpack_public_path__ + "static/media/banner3a.f9853974.png";